import React from 'react'

interface StudentDetailsCardProps {
    student: {
        first_name?: string;
        middle_name?: string;
        last_name?: string;
        grade_name?: string;
        roll_number?: string;
        gender?: string;
    };
}

const StudentDetailsCard: React.FC<StudentDetailsCardProps> = ({ student }) => {
    return (
        <>
            <div className="external-event" style={{backgroundColor: "#ffd316", position: 'relative', zIndex: 'auto', left: '0px', top: '0px', width: '15%', fontWeight: 400, cursor:'default'}}>Student Details</div>
            <div className="card">
                <div className="card-body" style={{backgroundColor: '#f9f1cc', padding: '15px'}}>
                    <div className="row">
                        <div className="col-sm-3">
                            <strong>Student Name:</strong>
                            <div style={{marginTop: '3px'}}>{[student?.first_name, student?.middle_name, student?.last_name].filter(Boolean).join(' ')}</div>
                        </div>
                        <div className="col-sm-3">
                            <strong>Roll Number:</strong>
                            <div style={{marginTop: '3px'}}>{ student?.roll_number ?? '---'}</div>
                        </div>
                        <div className="col-sm-3">
                            <strong>Year Group:</strong>
                            <div style={{marginTop: '3px'}}>{ student?.grade_name ?? '---'}</div>
                        </div>
                        <div className="col-sm-3">
                            <strong>Gender:</strong>
                            <div style={{marginTop: '3px', textTransform: 'capitalize'}}>{ student?.gender ?? '---'}</div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default StudentDetailsCard;
